<!-- Preloader Start -->
<!--<div id="preloader-active">-->
<!--  <div class="preloader d-flex align-items-center justify-content-center">-->
<!--    <div class="preloader-inner position-relative">-->
<!--      <div class="preloader-circle"></div>-->
<!--      <div class="preloader-img pere-text">-->
<!--        <img src="assets/img/23232.png" alt="">-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->
<!-- Preloader Start -->
<header>
  <!-- Header Start -->
  <div class="header-area header-transparrent bg-white ">

    <div class="navy-bar d-flex flex-row justify-content-start">
      <div>
        <span class="lang">  العربية</span>

      </div>
      <div class="col-md-8 text-center">

        <span class="header-text">لطلب نسخة تجريبية     info@tracllo.com </span>

      </div>






    </div>

    <div class="main-header header-sticky" dir="ltr">
      <div class="bg-white">
        <div class="row m-0">
          <!-- Logo -->
          <div class="col-xl-2 col-lg-2 col-md-2">
            <div class="logo-section">
              <div><a routerLink="/"><img src="../../assets/img/23232.png" class="logo" alt=""></a></div>
              <div class="logo-desc text-center">Tracllo</div>
            </div>
          </div>
          <div class="col-xl-9 col-lg-9 col-md-9 mobile">
           
          </div>

          <!-- Mobile Menu -->
          <div class="col-12">
            <div class="mobile_menu d-block d-lg-none"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- Header End -->
</header>
<div class="bg-white">
<main class="home-privacy container-fluid" style="max-width: 1320px;">

  <div class="home-main-header">
      <h1>سياسة الخصوصية الخاصة بتراكلو ( السياسة )</h1>
      <h2>ستوضح سياسة الخصوصية هذه ("السياسة") كيفية استخدامنا للبيانات الشخصية التي نجمعها عند دخولك إلى موقعنا ("الموقع") وأي من خدماتنا.</h2>
      <h2 class='cerise'>خصوصيتك مهمة بالنسبة لنا. إذا كنت لا توافق على شروط هذه السياسة، يرجى التوقف عن استخدامك لخدماتنا.</h2>
  </div>

  <div class="home-main-header applies-to">
    <h2>تنطبق سياسة الخصوصية هذه ("السياسة") على استخدامك لــ :</h2>
    <ol>
        <li>موقع تراكلو الإلكتروني الذي يتم استضافته على موقع www.tracllo.com والذي يمكن الوصول إليه عبر الحاسوب المكتبي أو شبكة الانترنت عن طريق الهاتف المحمول أو تطبيق الهاتف المحمول أو المنصة ("الموقع") ، بمجرد تنزيل نسخة من التطبيق أو تصفحها على هاتفك المحمول أو جهازك المحمول ("الجهاز").</li>
        <li>أي من الخدمات التي يمكن الوصول إليها من خلال الموقع (”الخدمة“). تحدد هذه السياسة الأساس الذي تتم بواسطته معالجة أي بيانات شخصية نجمعها منك، أو التي تقدمها لنا.        </li>
        <li>هذا الموقع ليس مخصصًا للأطفال .</li>
    </ol>
  </div>

  <div class="home-main-header quick-links">
    <h2>للوصول إلى موضوع محدد، يرجى الاختيار من القائمة التالية:</h2>
    <ul>
        <li>
            <a (click)="goToDiv('tracllo')">ما هو تراكلو</a>
        </li>
        <li>
            <a (click)="goToDiv('contact')">اتصل بنا</a>
        </li>
        <li>
            <a (click)="goToDiv('privacy-changes')">التغييرات في سياسة الخصوصية وواجبك في إبلاغنا بالتغييرات</a>
        </li>
        <li>
            <a (click)="goToDiv('third-party-links')">روابط الطرف الثالث</a>
        </li>
        <li>
            <a (click)="goToDiv('data-collect')">البيانات التي نجمعها عنك</a>
        </li>
        <li>
            <a (click)="goToDiv('how-collect-data')">كيف نجمع البيانات</a>
        </li>
        <li>
            <a (click)="goToDiv('cookies')">الكوكيز (ملفات تعريف الارتباط)</a>
        </li>
        <li>
            <a (click)="goToDiv('disclosure-personal-data')">الإفصاح عن بياناتك الشخصية</a>
        </li>
        <li id='contact'>
            <a (click)="goToDiv('data-protection')">حماية البيانات</a>
        </li>
    </ul>
</div>

<div class="home-main-header changes" id='tracllo'>
  <h2>ما هو تراكلو :</h2>
  <h3>هو تطبيق لإدارة النقل الجامعي يهدف إلى خدمة: (1) الطلاب (2) سائقي الحافلات و (3) إدارة النقل بالجامعة. تساعد Tracllo في تسهيل نقل الطلاب من وإلى الجامعات الخاصة من خلال تتبع حركة الحافلات عبر أجهزتهم المحمولة في الوقت الفعلي، وتجنب فترات الانتظار الطويلة في الشتاء أو الصيف عن طريق الحجز المسبق للرحلة ومعرفة وقت الوصول الفعلي للحافلات. بالإضافة إلى عدم الحاجة للتواصل المستمر مع سائقي الحافلات (من دائرة النقل والطلاب) من أجل إرباكهم أثناء القيادة.</h3>
  <h3>علاوة على ذلك، يجلب Tracllo العديد من الفوائد للجامعة بما في ذلك: (1) أتمتة وجدولة عملية نقل الطلاب وتوفير التكاليف على الحافلات التي تعمل حسب الحاجة ، (2) منع الأشخاص غير المصرح لهم (غير المشاركين) من استخدام الحافلات ، و (3) توفير نظام تعقب مجاني متقدم يوضح موقع كل حافلة وعدد المقاعد الفارغة فيها، و (4) توفير خدمة البث الإخباري للطلاب.</h3>
</div>

<div class="home-main-header call-us">
  <h2>اتصل بنا :</h2>
  <ul id='privacy-changes'>
      <li>عنوان البريد الإلكتروني: info@tracllo.com</li>
      <li>رقم الهاتف: </li>
  </ul>
  <h2>يحق لك تقديم شكوى في أي وقت للسلطة الرقابية المختصة.</h2>
</div>

<div class="home-main-header changes">
  <h2>التغييرات في سياسة الخصوصية وواجبك في إبلاغنا بالتغييرات :</h2>
  <h3>تخضع سياسة الخصوصية هذه للمراجعة بشكل مستمر.</h3>
  <div style="margin: 20px 0">
      <h3>رقم الإصدار : PP0001/22</h3>
      <h3>تاريخ الإصدار : 01/03/2022</h3>
  </div>
  <h3 id='third-party-links'>قد تتغير هذه السياسة، وإذا تغيرت، فسيتم إشعارك بهذه التغييرات عند الحاجة، بموجب رسالة نصية قصيرة أو عبر البريد الإلكتروني أو عند قيامك بزيارة الموقع في المرة القادمة. قد يتم عرض السياسة الجديدة على الشاشة وقد يُطلب منك قراءة التغييرات وقبولها لمتابعة استخدامك للموقع أو الخدمات.</h3>
  <h3>من المهم أن تكون البيانات الشخصية التي نحصل عليها من قبلك دقيقة وحديثة. يجب أن تبقينا على اطلاع إذا تغيرت بياناتك الشخصية خلال علاقتنا معك.</h3>
</div>

<div class="home-main-header changes">
  <h2>روابط الطرف الثالث :</h2>
  <h3>قد يحتوي موقعنا، من وقت لآخر، على روابط إلى ومن المواقع الإلكترونية لشبكات شركائنا والمعلنين والشركات التابعة.</h3>
  <h3 id="data-collect">يرجى ملاحظة أن هذه المواقع وأي خدمات يمكن الوصول إليها من خلالها لديها سياسات الخصوصية الخاصة بها ، وأننا لا نتحمل أي مسؤولية عن هذه السياسات أو عن أي بيانات شخصية قد يتم جمعها من خلال هذه المواقع أو الخدمات، مثل الاتصال والموقع.</h3>
  <h3>يرجى التحقق من هذه السياسات قبل إرسال أي بيانات شخصية إلى هذه المواقع أو استخدام هذه الخدمات.</h3>
</div>

<div class="home-main-header collect-data changes">
  <h2>البيانات التي نجمعها عنك :</h2>
  <h3>نقوم بجمع البيانات منك عند وصولك إلى موقعنا الإلكتروني و / أو استخدام نظام ادرة المشاريع القائم على نظام تراكلو الخاص بنا. يشمل ذلك جميع الأجهزة والمنتجات والخدمات التي تقدمها الشركة عبر موقعنا الإلكتروني وتطبيقات البرامج وجميع الخدمات المرتبطة بها (يُشار إليها إجمالاً باسم "الخدمات").</h3>
  <br>
  <h3>يجوز لنا جمع واستخدام وتخزين ونقل أنواع مختلفة من البيانات الشخصية عنك على النحو التالي :</h3>
  <ul>
    <li>معلومات التعريف الشخصية التي تعطينا اياها عن علم عند إنشاء حساب أو نشر المحتوى أو إجراء عملية شراء أو أي نماذج عبر الإنترنت .</li>
    <li>التفاصيل الشخصية مثل الاسم وبلد الإقامة وما إلى ذلك.</li>
    <li>بيانات الاتصال مثل عنوان البريد الإلكتروني والعنوان</li>
    <li>تفاصيل الحساب مثل اسم المستخدم ومعرف المستخدم وكلمة المرور.</li>
    <li>البيانات المالية</li>
    <li>بيانات المعاملات</li>
    <li>بيانات الجهاز</li>
    <li>بيانات المحتوى</li>
    <li>بيانات الملف الشخصي</li>
    <li>بيانات الاستخدام</li>
    <li>بيانات التسويق والاتصالات</li>
    <li>بيانات الموقع</li>
    <li>أي مواد أخرى ترسلها إلينا بمحض إرادتك مثل المقالات والصور والتعليقات وما إلى ذلك.</li>
    <li>المعلومات التي تقدمها لنا مباشرة والتي لا تحدد هويتك الشخصية ، بما في ذلك العمر والجنس والرمز البريدي والاهتمامات والتفضيلات فيما يتعلق بخدماتنا.</li>
    <li>المعلومات التي يتم جمعها تلقائيًا عند الوصول إلى خدماتنا</li>
  </ul>
  <h3>يجوز لنا أيضًا جمع واستخدام ومشاركة البيانات المجمعة مثل البيانات الإحصائية أو الديموغرافية لأي غرض من الأغراض. يمكن الحصول على البيانات المجمعة من بياناتك الشخصية ولكن لا تُعتبر بيانات شخصية في القانون لأن هذه البيانات لن تكشف عن هويتك بشكل مباشر أو غير مباشر. على سبيل المثال ، قد نقوم بتجميع بيانات الاستخدام الخاصة بك لحساب النسبة المئوية للمستخدمين الذين يصلون إلى ميزة معينة في الموقع. ومع ذلك، إذا قمنا بدمج مجموع البيانات أو توصيلها ببياناتك الشخصية حتى تتمكن من التعريف بك بشكل مباشر أو غير مباشر، فإننا نتعامل مع مجموع البيانات على أنها بيانات شخصية سيتم استخدامها وفقًا لسياسة الخصوصية هذه.</h3>
  <h3 id="how-collect-data">باستثناء ما هو منصوص عليه في هذه السياسة، فإننا لا نجمع أي فئات خاصة من البيانات الشخصية عنك (بما في ذلك تفاصيل عن جنسك أو عرقك أو معتقداتك الدينية أو الفلسفية أو الحياة الجنسية أو الآراء السياسية أو معلومات عن صحتك، والبيانات الوراثية). كما لا نقوم بجمع بيانات حول السجل الجرمي الخاص بك.</h3>
</div>

<div class="home-main-header collect-data changes">
  <h2>كيف نجمع البيانات :</h2>
  <h3>أنت تزود شركتنا مباشرة بمعظم البيانات التي نجمعها. نجمع البيانات ونعالج البيانات عندما:</h3>
  <ul>
    <li>سجل عبر الإنترنت أو قدم طلبًا لأي من منتجاتنا أو خدماتنا.</li>
    <li>أكمل طوعًا استطلاع رأي العملاء أو قدم ملاحظات على أي من لوحات الرسائل الخاصة بنا أو عبر البريد الإلكتروني.</li>
    <li>الوصول إلى خدماتنا عبر ملفات تعريف الارتباط بالمتصفح الخاص بك.</li>
    <li>التفاعل أو التسجيل في خدماتنا المقدمة من خلال الشركات التابعة لجهات خارجية.</li>
    <li>البيانات المشتركة من قبل شركاء تراكلو الآخرين.</li>
    <li id="cookies">البيانات التي تقع في المجال العام.</li>
    <li>البيانات المقدمة من طرف ثالث مستقل دون التعدي على أي واجب قانوني للحفاظ على هذه البيانات.</li>
  </ul>
</div>

<div class="home-main-header changes">
  <h2>الكوكيز (ملفات تعريف الارتباط) :</h2>
  <h3>نحن نستخدم ملفات الكوكيز و/ أو تقنيات التتبع الأخرى لتمييزك عن المستخدمين الآخرين للموقع ولمعرفة وتذكر مفضلاتك. وهذا يساعدنا على تزويدك بتجربة جيدة عند استخدام الموقع ويسمح لنا أيضًا بتحسين الموقع. للحصول على معلومات تفصيلية حول ملفات الكوكيز التي نستخدمها، والأغراض التي نستخدمها من أجلها، وكيف يمكنك ممارسة اختياراتك، لمزيد من المعلومات حول ملفات تعريف الارتباط، تفضل بزيارة allaboutcookies.org.</h3>
</div>

<div class="home-main-header changes">
  <h2>متى نجمع ملفات تعريف الارتباط ؟</h2>
  <h3>نقوم بجمع ملفات تعريف الارتباط هذه عندما تدخل إلى موقعنا الإلكتروني و / أو تستخدم أيًا من خدماتنا. نقوم أيضًا بجمع ملفات تعريف الارتباط هذه عندما تتفاعل مع خدماتنا المقدمة من خلال أحد شركائنا.</h3>
</div>

<div class="home-main-header collect-data changes">
  <h2>كيف نستخدم ملفات تعريف الارتباط؟</h2>
  <h3>تستخدم شركتنا ملفات تعريف الارتباط بعدة طرق لتحسين تجربتك على موقعنا الإلكتروني وتقديم تجربة أكثر سهولة وإرضاءً، بما في ذلك:</h3>
  <ul>
    <li>الاحتفاظ بتسجيل الدخول</li>
    <li>حماية بياناتك وحسابك</li>
    <li>فهم كيفية استخدامك لخدماتنا</li>
    <li>حفظ تفضيلاتك فيما يتعلق بخدماتنا</li>
    <li>مساعدتنا في معرفة الميزات الأكثر شيوعًا</li>
    <li>عدد زوار الصفحة</li>
    <li>الحفاظ على خدماتنا آمنة</li>
  </ul>
</div>

<div class="home-main-header collect-data">
  <h2>ملفات تعريف الارتباط التي نستخدمها :</h2>
  <ul>
    <li>ملفات تعريف الارتباط ذات الضرورة القصوى. هي ملفات تعريف الارتباط اللازمة لتشغيل موقعنا الالكتروني. فهي تتضمن على سبيل المثال، ملفات تعريف الارتباط التي تمكنك من الدخول الى مناطق آمنة على موقعنا الالكتروني او استخدام عربة التسوق او الاستفادة من خدمات الفوترة الالكترونية.</li>
    <li>ملفات تعريف الارتباط التحليلية او الخاصة بالأداء. تسمح لنا هذه بالتعرف على وتعداد الزوار ورؤية كيفية تنقل الزوار عبر موقعنا الالكتروني عندما يقوموا باستخدامه. يعمل ذلك على مساعدتنا لتحسين الأسلوب الذي يعمل فيه موقعنا الالكتروني، على سبيل المثال، عن طريق الضمان بقيام المستخدمين بإيجاد ما يبحثون عنه بسهولة.</li>
    <li>ملفات تعريف الارتباط التشغيلية. يتم استخدام هذه للتعرف عليك عندما تعود لموقعنا الالكتروني. يعمل ذلك على تمكيننا لتخصيص المحتوى الخاص بنا شخصيا لك وتقديم التحية باسمك واستذكار تفضيلاتك (على سبيل المثال، اختيارك اللغة او المنطقة).</li>
    <li>ملفات تعريف الارتباط الاستهدافية. تعمل ملفات تعريف الارتباط هذه على قيد زيارتك لموقعنا الالكتروني والصفحات التي قمت بزيارتها والروابط التي اتبعتها. نقوم باستخدام هذه المعلومات لجعل موقعنا الالكتروني والدعاية المعروضة فيه اكثر صلة باهتماماتك. قد نقوم أيضا بمشاركة هذه المعلومات مع أطراف ثالثة لهذا الغرض.</li>
  </ul>
</div>

<div class="home-main-header changes">
  <h2>ملفات تعريف الارتباط والأطراف الثالثة :</h2>
  <h3>يرجى الملاحظة بأن أطراف ثالثة قد تقوم باستخدام ملفات تعريف الارتباط التي ليس لدينا سيطرة عليها. قد تتضمن الأطراف الثالثة هذه، على سبيل المثال، شبكات دعاية ومزودي خدمات خارجيين مثل خدمات تحليل الحركة عبر الموقع الالكتروني. من المحتمل ان تكون ملفات تعريف الارتباط هذه الخاصة بالطرف الثالث ملفات تعريف ارتباط تحليلية او ملفات تعريف ارتباط خاصة بالأداء او ملفات تعريف ارتباط استهدافية.</h3>
  <br>
  <h3>يمكنك حجب ملفات تعريف الارتباط بتفعيل الإعداد على جهاز التصفح الخاص بك الذي يسمح لك برفض الإعداد لبعض او كافة ملفات تعريف الارتباط. مع ذلك، إذا قمت باستخدام إعدادات جهاز التصفح الخاص بك لحجب كافة ملفات تعريف الارتباط (بما في ذلك ملفات تعريف الارتباط الأساسية)، فإنك قد لا تكون قادرا على الوصول الى كامل موقعنا الالكتروني او أجزاء منه.</h3>
</div>

<div class="home-main-header collect-data changes">
  <h2>كيف نستخدم بياناتك الشخصية ( الغايات التي سنستخدم فيها بياناتك الشخصية )؟</h2>
  <h3>نحن لا نجمع معلومات عنك ما لم يسمح لنا القانون بذلك وما لم نحتاج إلى هذه المعلومات لتقديم خدماتنا. بالإضافة إلى بعض الاستخدامات المحددة التي تغطيها هذه السياسة ، تجمع شركتنا بياناتك من أجل:</h3>
  <ul>
    <li>إنشاء وإدارة حساباتك</li>
    <li>تلبية وإدارة طلباتك</li>
    <li>تقديم المنتجات والخدمات</li>
    <li>إرسال المعلومات الإدارية، بما في ذلك عن طريق البريد الإلكتروني</li>
    <li>إرسال اتصالات تسويقية وترويجية، بما في ذلك عبر البريد الإلكتروني</li>
    <li>الرد على الطلبات والاستفسارات</li>
    <li>تطوير خدماتنا وتشغيلها وتحسينها وتقديمها وصيانتها</li>
    <li>مراقبة وتحليل الاتجاهات والاستخدام</li>
    <li>تعزيز سلامة وأمن خدماتنا</li>
    <li>التحقق من هويتك ومنع الاحتيال أو أي نشاط غير مصرح به أو غير قانوني</li>
    <li>فرض الشروط والأحكام الخاصة بنا وسياسات الاستخدام الأخرى</li>
    <li>طلب ملاحظات المستخدم</li>
    <li>تحسين تجربة المستخدم</li>
    <li>نشر شهادات العملاء</li>
    <li>تقديم إعلانات مستهدفة</li>
    <li>عندما نحتاج إلى تنفيذ عقد، أو إذا كنا على وشك الدخول فيه أو تم التعاقد عليه معك.</li>
    <li>عندما يكون ذلك ضروريًا لمصالحنا المشروعة (أو مصالح طرف ثالث) ولا تسمو مصالحك وحقوقك الأساسية على تلك المصالح.</li>
    <li>عندما نحتاج إلى الامتثال لالتزام قانوني أو تنظيمي.</li>
    <li>في حال موافقتك المسبقة قبل المعالجة.</li>
    <li id="disclosure-personal-data">لمعالجة عمليات الشراء داخل الموقع وتقديم الخدمات بما في ذلك إدارة المدفوعات وجمع الأموال المستحقة لنا (إن وجدت).</li>
    <li>إدارة وحماية أعمالنا، بما في ذلك اكتشاف الأخطاء وإصلاحها وتحليل البيانات واختبار النظام.</li>
  </ul>
</div>

<div class="home-main-header collect-data changes">
  <h2>الإفصاح عن بياناتك الشخصية</h2>
  <h3>عندما توافق على تزويدنا ببياناتك الشخصية، سنطلب منك أيضا الموافقة على مشاركتك لبياناتك الشخصية مع الأطراف الثالثة المبينين ادناه للغايات المبينة في القائمة التي نبين فيها (الغايات التي سنستخدم فيها بياناتك الشخصية).</h3>
  <ul>
    <li>الأطراف الثالثة الداخلية</li>
    <li>الأطراف الثالثة التي قد نختار بيع أو نقل أو دمج أجزاء من أعمالنا أو أصولنا لها. بدلاً من ذلك ، قد نسعى إلى تملك شركات أخرى أو الاندماج معها. في حال حدوث تغيير في أعمالنا، يجوز للمالكين الجدد استخدام بياناتك الشخصية بذات الطريقة المنصوص عليها في سياسة الخصوصية هذه.</li>
    <li>مشاركة بياناتك لأغراض تجارية</li>
    <li>قد نكشف عن معلوماتك إلى الجهات التالية :
      <ul>
        <li>موظفينا</li>
        <li>مستشارونا المحترفون ، بما في ذلك على سبيل المثال لا الحصر المستشارين الماليين والقانونيين والإداريين</li>
        <li>الكيانات المؤسسية أو الكيانات التابعة لنا</li>
        <li>مستشارونا ، بما في ذلك كيانات أبحاث السوق ووكالات الإعلان ، إلخ</li>
        <li>أي متنازل عنه أو متنازل له عن حقوق تراكلو ضد المستهلكين</li>
        <li>أي شخص ندخل في علاقات تعاقدية معه لمساعدتنا في تقديم خدماتنا</li>
        <li>الأطراف الثالثة التي نحتاج إلى مشاركة المعلومات معها للوفاء بأي طلب محدد ترسله إلينا</li>
      </ul>
    </li>
    <li>عندما نقوم بنقل بياناتك الشخصية خارج بلدك، فإننا نضمن منحها درجة حماية مماثلة من خلال ضمان توافر أحد الضمانات الآتية على الأقل :
      <ul>
        <li>سنقوم بنقل بياناتك الشخصية فقط للدول التي اعتبرت انها تقدم درجة حماية كافية للبيانات الشخصية</li>
        <li>حيثما نستخدم مزودي خدمات معينين، قد نستخدم عقود معينة تمنح درجة حماية كافية حماية للبيانات الشخصية</li>
        <li>يرجى التواصل معنا في حال اردت الحصول على معلومات إضافية عن نقل بياناتك الشخصية خارج بلدك .</li>
      </ul>
    </li>
  </ul>
  <div>
    <h2 class="sub-h2 navy-blue">مشاركة بياناتك لأغراض قانونية</h2>
    <h3>قد نشارك معلومات عنك إذا طلبت ذلك الهيئات أو الوكالات الحكومية أو المنظمون إذا اعتقدنا بشكل معقول أن الكشف عن المعلومات ضروري من أجل :</h3>
    <ol>
      <li>الالتزام بأي إجراء قانوني أو طلب حكومي أو قانون أو قاعدة أو لائحة سارية</li>
      <li>التحقيق في انتهاكات البنود والشروط المحتملة أو تصحيحها أو تنفيذها</li>
      <li>حماية حقوقنا وممتلكاتنا وسلامتنا أو مستخدمينا أو غيرهم</li>
      <li>اكتشاف أي احتيال أو مخاوف أمنية وحلها</li>
    </ol>
    <h3>قد يشمل ذلك الاستجابة للطلبات القانونية من ولايات قضائية خارج بلدك حيث لدينا اعتقاد حسن النية أن الاستجابة مطلوبة بموجب القانون في تلك الولاية القضائية ، وتؤثر على المستخدمين في تلك الولاية القضائية ، وتتوافق مع المعايير المعترف بها دوليًّا :</h3>
  </div>
  <div style="margin-top: 50px;">
    <h2 class="sub-h2 navy-blue">ومع ذلك ، فإننا نشارك بياناتك فقط مع الكيانات المذكورة أعلاه وفقًا للشروط التالية مجتمعة :</h2>
    <ol>
      <li>نحن مطالبون بمشاركة هذه المعلومات حتى نتمكن من تقديم خدماتنا ومعالجتها وتطويرها وتحسينها.</li>
      <li>يسمح لنا القانون بمشاركة هذه المعلومات</li>
      <li>نحن نحصر المعلومات التي نشاركها بالقدر الضروري لتحقيق الغرض</li>
      <li>توافق الجهة المعنية كتابةً على عدم إفشاء هذه المعلومات للآخرين.</li>
      <li id="data-protection">قد يكون بعض الموظفين والمستشارين المحترفين والمقاولين والمنظمات التابعة المذكورين أعلاه موجودين خارج بلدك ؛ باستخدام الخدمات ، فإنك توافق على نقل هذه المعلومات إليها إلى الحد المسموح به بموجب القانون المعمول به.</li>
    </ol>
  </div>
</div>

<div class="home-main-header collect-data changes">
  <h2>حماية البيانات</h2>
  <h3>يتم تخزين جميع المعلومات التي تقدمها لنا على خوادمنا الآمنة. سيتم تشفير أي معاملات دفع أجريناها من قبل موقعنا أو من قبل طرف ثالث مقدم للخدمة مختار من قبلنا لخدمات معالجة الدفع باستخدام تقنية طبقة الوصلات الآمنة. حيثما قدمنا لك (أو حيث اخترت) كلمة مرور تمكنك من الوصول إلى أجزاء معينة من الموقع، فأنت مسؤول عن الحفاظ على سرية كلمة السر هذه. نطلب منك عدم مشاركة كلمة السر مع أي شخص.</h3>
  <h3>بمجرد أن نتلقى معلوماتك، سنستخدم إجراءات صارمة وميزات أمان لمحاولة منع فقدان بياناتك الشخصية أو استخدامها أو الوصول إليها بطريقة غير مصرح بها عن طريق الخطأ.</h3>
  <h3>سنقوم بجمع وتخزين البيانات الشخصية على جهازك باستخدام ذاكرات بيانات التطبيق وتخزين الويب للمتصفح (بما في ذلك HTML5).</h3>
  <h3>تشمل بعض الخدمات ميزات مواقع التواصل الاجتماعي أو غرف الدردشة أو المنتديات. عند استخدامك لهذه الميزات تأكد من ان لا تقوم بإرسال أي بيانات شخصية لا تريد رؤيتها أو جمعها أو استخدامها من قبل مستخدمين آخرين.</h3>
</div>

<div class="home-main-header collect-data changes">
  <h2>حماية البيانات</h2>
  <h3>تود شركتنا التأكد من أنك على دراية كاملة بجميع حقوق حماية البيانات الخاصة بك. يحق لكل مستخدم ما يلي :</h3>
  <ul>
    <li>الحق في الوصول - يحق لك أن تطلب من شركتنا نسخًا من البيانات الشخصية التي جمعناها منك في ظل ظروف معينة.</li>
    <li>الحق في التصحيح - يحق لك أن تطلب من شركتنا تصحيح أي معلومات تعتقد أنها غير دقيقة. لديك أيضًا الحق في مطالبة شركتنا بإكمال المعلومات التي تعتقد أنها غير كاملة في ظل ظروف معينة.</li>
    <li>الحق في المسح - لك الحق في مطالبة شركتنا بمسح بياناتك الشخصية، في ظل ظروف معينة.</li>
    <li>الحق في تقييد المعالجة - يحق لك أن تطلب من شركتنا تقييد معالجة بياناتك الشخصية، في ظل ظروف معينة.</li>
    <li>الحق في الاعتراض على المعالجة - يحق لك الاعتراض على معالجة شركتنا لبياناتك الشخصية، في ظل ظروف معينة.</li>
    <li>الحق في نقل البيانات - يحق لك أن تطلب من شركتنا نقل البيانات التي جمعناها إلى مؤسسة أخرى، أو إليك مباشرةً، في ظل ظروف معينة.</li>
    <li>في بعض الحالات، سنعمل على إخفاء هوية بياناتك الشخصية (بحيث لا يمكن ربطها بك) لغايات بحثية أو إحصائية، حيث قد نستخدم في هذه الحالة هذه المعلومات إلى أجل غير مسمى دون إشعار آخر لك.</li>
  </ul>
  <h3>إذا كنت ترغب في ممارسة أي من هذه الحقوق، فيرجى الاتصال بنا على بريدنا الإلكتروني: support@tracllocom.</h3>
</div>

<div class="home-main-header collect-data">
  <h2>الأساس القانوني</h2>
  <ul>
    <li>الموافقة تعني معالجة بياناتك الشخصية حيثما قمت بالتعبير عن موافقتك من خلال بيان أو الاشتراك في المعالجة لغرض معين. تكون الموافقة فعالة في حال أعطيت بإرادة حرة ومحددة ومطلعة ولا لبس فيها فيما يتعلق بما تريد. يمكنك سحب موافقتك في أي وقت عن طريق التواصل معنا.</li>
    <li>المصلحة المشروعة تعني مصلحة عملنا في القيام بأعمالنا وإدارتها لتمكيننا من تزويدك بأفضل خدمة/منتج وأفضل تجربة وأكثرها أمانًا. نقوم بالتأكد من دراسة وموازنة أي تأثير محتمل عليك (سواء كان إيجابًا أو سلبًا) وعلى حقوقك قبل أن نعالج بياناتك الشخصية لمصالحنا المشروعة. لا نستخدم بياناتك الشخصية في الأنشطة التي يتم فيها تجاوز اهتماماتنا بسبب التأثير عليك (ما لم نحصل على موافقتك أو اذا كانت مطلوبة أو مسموحة من قبل القانون خلافا لذلك). يمكنك الحصول على المزيد من المعلومات حول كيفية تقييمنا لمصالحنا المشروعة مقابل أي تأثير محتمل عليك فيما يتعلق بأنشطة محددة من خلال التواصل معنا.</li>
    <li>تنفيذ العقد يعني معالجة بياناتك حيثما يكون ذلك ضروريًّا لتنفيذ العقد الذي تكون طرفًا فيه أو لاتخاذ خطوات بناءً على طلبك قبل الدخول في هذا العقد.</li>
    <li>الامتثال لالتزام قانوني يعني معالجة بياناتك الشخصية حيثما يكون ذلك ضروريًا للامتثال لالتزام قانوني نخضع له.</li>
  </ul>
  <h2 class="sub-h2 black">الأطراف الثالثة</h2>
  <ul>
    <li>الأطراف الثالثة الداخلية وهي شركات أخرى ضمن شركة تراكلو للتكنولوجيا تقوم بدور مسؤولين عن المعالجة أو معالجين للبيانات مشتركين واللذين يكون مقرهم داخل أو خارج الأردن وتوفير خدمات تكنولوجيا المعلومات وإدارة النظام وتتولى إعداد تقارير القيادة.</li>
    <li>الأطراف الثالثة الخارجية يقدم مزودو الخدمات الذين يعملون كمعالجين ومقرهم داخل أو خارج الأردن خدمات تكنولوجيا المعلومات وإدارة النظام. المستشارون المحترفون الذين يعملون كمعالجين أو مسؤولين مشتركين عن المعالجة ويشمل ذلك المحامون والمصرفيون ومدققو الحسابات وشركات التأمين وذلك بناء على من يقوم بتزويد خدمات الاستشارات والخدمات المصرفية والقانونية والتأمينية والمحاسبية. الهيئات التنظيمية والسلطات الأخرى.</li>
    <li>المستشارون المحترفون الذين يعملون كمعالجين أو مسؤولين مشتركين عن المعالجة ويشمل ذلك المحامون والمصرفيون ومدققو الحسابات وشركات التأمين وذلك بناء على من يقوم بتزويد خدمات الاستشارات والخدمات المصرفية والقانونية والتأمينية والمحاسبية.</li>
    <li>الهيئات التنظيمية والسلطات الأخرى.</li>
  </ul>
</div>

</main>
</div>
<footer class="text-white" dir="ltr">

  <div class=" col-lg-12   mb-5 pb-5" >
    <div class="row">
      <div class="d-flex flex-column col-lg-2">
        <div class="text-center">
          <img src="../../assets/img/23232.png" style="margin: unset!important;" class="logo width-121" >
        </div>
        <div class="text-white text-center mt-3"><span class="" style="font-size: 30px">Tracllo</span></div>
      </div>
      <div class="d-flex flex-column col-lg-4">
        <div class="mb-5">
          <h2 class="text-white">Quick Links</h2>
        </div>
        <div class="text-white font-12 mb-2"><a href="https://play.google.com/store/apps/details?id=com.tracllo">Tracllo for student app on Google store</a></div>
        <div class="text-white font-12 mb-2"><a href="https://play.google.com/store/apps/details?id=com.tracllodriver">Tracllo for Driver app on Google store</a></div>
        <div class="text-white font-12 mb-2"><a href="http://tracllo.com/login">Tracllo System on browsers</a></div>
         </div>

      <div class="d-flex flex-column col-lg-4">
        <div class="mb-5">
          <h2 class="text-white">Contact Information</h2>
        </div>
        <div class="text-white font-18   mb-2"><span>Jordan, Amman</span></div>
        <div class="text-white font-14 mb-1"><span>Queen Rania Street</span></div>
        <div class="text-white font-14  mb-3"><span>Opposite to Al Fanar Hotel - Qandil Building</span></div>
        <div class="text-white font-18  mb-2"><span>E : info@tracllo.com</span></div>
        <div class="text-white font-18  mb-2"><span>P : +963798981681</span></div>

      </div>
    </div>
  </div>




</footer>
<div class="" style="  background: #787bff;   padding: 30px;" dir="ltr">
  <div class="d-flex flex-row">
    <div class="">
      <img src="./assets/img/23232.png" class="ml-4" style="  width: 50px;border-radius: 100%;    border: 2px solid #ffffff;">

    </div>
    <div class="d-flex align-items-center flex-column justify-content-center  w-100">
<!--      <div class="d-flex flex-row">-->
<!--        <a href="https://web.facebook.com/Medlinic" class="facebook icon-social">-->
<!--          <i class="fa fa-facebook-f"></i>-->
<!--          <span>Facebook</span>-->
<!--        </a>-->
<!--        <a href="http://wa.me/9627985100278" class="twitter icon-social">-->
<!--          <i class="fa fa-whatsapp"></i>-->
<!--          <span>WhatApp</span>-->
<!--        </a>-->
<!--        <a href="https://www.instagram.com/medlinic" class="twitter icon-social">-->
<!--          <i class="fa fa-instagram"></i>-->
<!--          <span>Instagram</span>-->
<!--        </a>-->
<!--      </div>-->
      <div>

        <small class="text-white">&copy; Copyright 2020, <span class="">powered by Tracllo</span></small>


      </div>

    </div>


  </div>
</div>
